import BaseModel from './base';
import ExpertiseCriteria from './expertise-criteria';
import ExpertiseCriteriaGroup from './expertise-criteria-group';

export default class ExpertiseCriteriaSet extends BaseModel {
  constructor(set, url) {
    super(set, url);
    this.description = set.description || '';
    this.criterion_group = set.criterion_group ? new ExpertiseCriteriaGroup(set.criterion_group) : null;
    this.criteria = (set.criteria || []).map((item) => new ExpertiseCriteria(item));
  }
}
